module.exports = __webpack_public_path__ + "img/left-icon.91167c28.png";